import type { SetupStepId } from '@/types';

/**
 * Feature surfaces announce "something I own just changed" instead of reaching
 * into the setup store. Same `CustomEvent` idiom the billing feature-lock uses,
 * and it keeps the mutation sites (posts store, competitor store, the Knowledge
 * Base page, Brand DNA, chat) free of any dependency on the setup UI.
 */
export const SETUP_PROGRESS_EVENT = 'setup:progress-changed';

export interface SetupProgressEventDetail {
  step: SetupStepId;
  /**
   * Flip the step to complete immediately, before the confirming fetch lands.
   * Only pass this when the action itself is sufficient proof (adding a
   * competitor, approving a post) — never for work the backend finishes
   * asynchronously, like knowledge-base indexing.
   */
  optimistic?: boolean;
}

/** Tell the setup checklist that `step` needs revalidating. Safe to call anywhere. */
export function notifySetupProgress(step: SetupStepId, optimistic = false): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<SetupProgressEventDetail>(SETUP_PROGRESS_EVENT, {
      detail: { step, optimistic },
    })
  );
}
